import React, { useEffect } from "react";
import { WplywContext } from "../../../../../context/wplywContext";
import { useContext } from "react";
import { useState } from "react";
import numberFormat from "../../../../../components/numberFormat";
import formatPrice from "../../../../../components/formatPrice";

const ProgressBarReckonings = () => {
	const { wplyw } = useContext(WplywContext);
	const [procent, setProcent] = useState(0);
	const [totals, setTotals] = useState(
		parseFloat(
			(
				wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_amount -
				wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_deduction
			).toFixed(2),
		),
	);
	useEffect(() => {
		const total = wplyw.wplyw_data.data.msr_wplywy.msr_persons.reduce(
			(sum, person) =>
				sum +
				Math.round(parseFloat(person.msr_persons_amount || 0) * 100),
			0,
		);
		const totalCents = Math.round(totals * 100);
		setProcent(
			totalCents === 0 ? 0 : Math.round((total / totalCents) * 100),
		);
	}, [wplyw, totals]);
	useEffect(() => {
		setTotals(
			parseFloat(
				(
					wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_amount -
					wplyw.wplyw_data.data.msr_wplywy
						.msr_wplywy_primary_deduction
				).toFixed(2),
			),
		);
	}, [wplyw]);
	return (
		<div>
			<div
				style={{
					display: "flex",
					width: "100%",
					justifyContent: "center",
					padding: "10px",
					background: "#a5a5a5",
					borderRadius: "10px",
					position: "relative",
					overflow: "hidden",
					gap: "15px",
					alignItems: "center",
				}}
			>
				<div
					style={{
						width: Math.min(procent, 100) + "%",
						position: "absolute",
						height: "100%",
						background:
							wplyw.wplyw_data.data.msr_wplywy.msr_persons.reduce(
								(sum, person) =>
									sum +
									Math.round(
										parseFloat(
											person.msr_persons_amount || 0,
										) * 100,
									),
								0,
							) == Math.round(totals * 100)
								? "#52C41A"
								: "#DC0202",
						left: "0",
						top: "0",
					}}
				></div>
				<div
					style={{ position: "relative", zIndex: "4", width: "100%" }}
				>
					<div style={{ color: "white", textAlign: "right" }}>
						Kwota całkowita
					</div>
					<div
						style={{
							fontWeight: 700,
							fontSize: "18px",
							color: "white",
							textAlign: "right",
						}}
					>
						{numberFormat(totals)} zł ={" "}
						{numberFormat(
							wplyw.wplyw_data.data.msr_wplywy
								.msr_wplywy_primary_amount,
						)}{" "}
						zł -{" "}
						{numberFormat(
							wplyw.wplyw_data.data.msr_wplywy
								.msr_wplywy_primary_deduction,
						)}{" "}
						zł
					</div>
				</div>
				<div
					style={{
						height: "30px",
						width: "2px",
						background: "white",
						zIndex: "4",
					}}
				></div>
				<div
					style={{ position: "relative", zIndex: "4", width: "100%" }}
				>
					<div style={{ color: "white", textAlign: "left" }}>
						Rozpisana kwota klienta
					</div>
					<div
						style={{
							fontWeight: 700,
							fontSize: "18px",
							color: "white",
							textAlign: "left",
						}}
					>
						{wplyw.wplyw_data.data.msr_wplywy.msr_persons.reduce(
							(sum, person) =>
								sum +
								Math.round(
									parseFloat(person.msr_persons_amount || 0) *
										100,
								),
							0,
						) > Math.round(totals * 100)
							? "Kwota przekroczona o " +
								numberFormat(
									(
										(wplyw.wplyw_data.data.msr_wplywy.msr_persons.reduce(
											(sum, person) =>
												sum +
												Math.round(
													parseFloat(
														person.msr_persons_amount ||
															0,
													) * 100,
												),
											0,
										) -
											Math.round(totals * 100)) /
										100
									).toFixed(2),
								) +
								" zł"
							: wplyw.wplyw_data.data.msr_wplywy.msr_persons
									.map(
										(x) =>
											`${formatPrice(x.msr_persons_amount || 0)} zł`,
									)
									.join(" + ") +
								" = " +
								procent.toFixed(2) +
								"%"}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProgressBarReckonings;
